import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';

export class Poloviny implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const margin = PdfUnit.FromMillimeters(10);
    const { origin, size } = calcOrigin(1, 5, margin, PdfSize.A4);

    const pageCount = Math.ceil(opts.list.length / 5);

    for (let p = 0; p < pageCount; p++) {
      const page = pdf.addPage();
      const startIndex = p * 5;
      const endIndex = Math.min(startIndex + 5, opts.list.length);
      const pageItems = opts.list.slice(startIndex, endIndex);

      const cellWidth = (size.width - 4 * margin) / 3;

      const allTexts = pageItems.map((item) => [item.right.getText() ?? '']);
      const leftFont = page.adjustFontMulti(
        allTexts,
        GUtil.baseFont,
        new PdfSize(cellWidth, size.height)
      );
      const rightFont = page.adjustFontMulti(
        allTexts,
        GUtil.baseFont,
        new PdfSize(cellWidth, size.height)
      );

      const labelCellSize = new PdfSize(cellWidth, size.height);
      const labelFont = page.adjustFontMulti(
        pageItems.map((item) => [item.left.getText() ?? '']),
        GUtil.baseFont,
        labelCellSize
      );

      for (let i = 0; i < pageItems.length; i++) {
        const item = pageItems[i];
        const y = origin.y + size.height * i;

        const leftRect = new PdfRect(origin.x + margin, y, cellWidth, size.height);
        const centerRect = new PdfRect(
          origin.x + 2 * margin + cellWidth,
          y,
          cellWidth,
          size.height
        );
        const rightRect = new PdfRect(
          origin.x + 3 * margin + 2 * cellWidth,
          y,
          cellWidth,
          size.height
        );

        page.drawRectangle(GUtil.basePen, null, new PdfRect(origin.x, y, size.width, size.height));

        page.drawLabel(item.left, { rect: centerRect, font: labelFont });
        page.drawLine(
          GUtil.cutPen,
          new PdfPoint(centerRect.centerX, centerRect.y),
          new PdfPoint(centerRect.centerX, centerRect.bottom)
        );

        page.drawLabel(item.right, { rect: leftRect, font: leftFont });
        page.drawLabel(item.right, { rect: rightRect, font: rightFont });
      }
    }
  }
}
